
/*
Author: Vinod
Date: 06/01/2020
Emp Code Impl Description: Reporting Manager (Frontend Integration) & Alignment issue.
search_string: PL_2375, PL_2371
*/

/*
Author: Vinod
Date: 02/04/2020
Emp Code Impl Description: Not able to add selected employee to add LOP/RLOP.
search_string: PL_3009
*/

<template>
  <div class="selectdiv">
    <span class="input-label">{{label}}</span>
    <!-- <tl-search class="search-width" :value="empname" @change="filterData" @keyup="searchData"/> -->
    <div class="search-container">
      <input
        type="text"
        class="search-bar"
        :placeholder="placeholder"
        v-model="searchKey"
        autocomplete="off"
        name="search"
        @input="filterData"
      />
      <button type="button" @click="filterData">
        <img class="search-icon" src="@/assets/magnifying-glass.png" />
      </button>
      <span v-if="searchKey && clearRequired">
        <a href="javascript:void(0)" @click="reset()">Clear</a>
      </span>
    </div>
    <ul class="search-result" v-if="auto_suggestions && filterEmpData.length">
      <li v-for="(employee,index) in filterEmpData" :key="index" v-on:click="itemclicked(employee)">
        <div class="threeColumnGrid">
          <div class="img-part">
            <img :src="employee.photo_url" alt="img" />
          </div>
          <div class="empDetails">
            <div class="empName">
              <label>{{employee.first_name ? employee.first_name :''}} {{employee.last_name ? employee.last_name: ''}}</label>
            </div>
            <div class="empcode">
              <label>{{employee.code}}</label>
            </div>
            <div class="empcode">
              <label>{{employee.email_id}}</label>
            </div>
          </div>
          <div class="role">
            <!-- {{employee.role}} -->
          </div>
        </div>
      </li>
    </ul>
    <ul class="search-result" v-else-if="auto_suggestions && !filterEmpData.length">
      <li>No data Available</li>
    </ul>
  </div>
</template>

<script>
import { errorHandler } from "@/apis/variables.js";
export default {
  props: {
    employeeData: {
      required: true,
      default: []
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Search"
    },
    clearRequired: {
      type: Boolean,
      default: true
    },
    selectedEmp: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      filterEmpData: [],
      searchKey: this.selectedEmp, // PL_2371
      auto_suggestions: false
    };
  },
  activated() {
    this.reset();
  },
  mounted() {
    this.reset();
  },
  methods: {
    filterData() {
      try {
        // PL_2996
        if (this.searchKey.length >= 3) {
          this.$emit("getList", this.searchKey);
          setTimeout(() => {
            this.auto_suggestions = true;
            this.filterEmpData = this.employeeData;
          }, 500);
        } else {
          this.auto_suggestions = false;
        }
      } catch (error) {
        throw errorHandler(error.response);
      }
    },
    // searchData(key, array) {
    //   const final = [];
    //   for (let i = 0; i < array.length; i++) {
    //     let searchObj = array[i].name;
    //     if (
    //       searchObj != null &&
    //       searchObj.toLowerCase().search(key.toLowerCase()) !== -1
    //     ) {
    //       final.push(array[i]);
    //     }
    //   }
    //   return final;
    // },
    itemclicked(emp) {
      try {
        this.$emit("empselected", emp);
        this.searchKey = emp.first_name
          ? emp.first_name
          : "" + " " + emp.last_name
          ? emp.last_name
          : ""; // PL_3009
        this.auto_suggestions = false;
      } catch (error) {
        throw errorHandler(error.response);
      }
    },
    reset() {
      try {
        this.auto_suggestions = false;
        this.searchKey = "";
        this.filterEmpData = [];
        this.$emit("clear");
      } catch (error) {
        throw errorHandler(error.resposne);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.search-width {
  margin-top: 1%;
}
.search-result {
  position: absolute;
  width: 300px; // PL_2996
  background: #ffffff;
  max-height: 330px; // PL_2996
  border-radius: 4px;
  border: solid 1px #f7f7f7;
  overflow: auto;
  z-index: 1;
  li {
    padding: 15px;
    border-bottom: 0.5px solid #e3e3e3;
    margin-right: 0px !important;
    &:hover {
      background-color: #d6f2f2;
    }
  }
}
.threeColumnGrid {
  grid-column-gap: 0px;
}
.img-part {
  img {
    width: 50px;
    height: 50px;
  }
}
.empName label {
  font-size: 16px;
  color: #646464;
  margin-bottom: 4px;
}
.empcode label {
  font-size: 14px;
  color: #878787;
}
.role {
  color: #878787;
  align-self: center;
}
.search-container {
  width: 300px;
  position: relative;
  max-width: 321px;
  span {
    position: absolute;
    padding: 10px;
  }
}
.search-bar {
  width: 100%;
  border: 1px solid #d6d4d4;
  border-radius: 3px;
  height: 35px;
  padding: 5px;
  outline: none;
  position: relative;
}
.search-icon {
  position: absolute;
  right: 10px;
  top: 6px;
  width: 18px;
  height: 18px;
  left: inherit;
}
</style>
